export default {
  user: null,
  loading: false,
  error: null
}
